export const genreParamName = 'genre';
export const allGenresValue = 'ALL';
